module.exports = __webpack_public_path__ + "static/media/Sketch11.39ab1e21.jpeg";